module.exports = __webpack_public_path__ + "img/Quadrant 1.2 x 0.7.d2fe2aa3.jpg";